// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"657528f5","266":"f8b1145d","272":"8971a403","488":"d32e2916","627":"c04c9fcd","630":"d6e45989","703":"d6215414","724":"0d6a6ca5","732":"cac2fa60","825":"60af0415","885":"b93a002c","894":"13b9e870","981":"0cb88f81"}[chunkId] + ".chunk.js";
};